import React from 'react'
import { Link } from 'react-router-dom'

const Header = () => {
  return (
    <div className="container pt-4 mx-auto">
      <div className="float-right">
        <Link to="/home" class="text-blue-500 text-lg no-underline hover:underline mr-5">
          Home
        </Link>
        <Link to="/policy" class="text-blue-500 text-lg no-underline hover:underline">
          Policy
        </Link>
      </div>
    </div>
  )
}

export default Header
